<template>
  <b-dropdown class="light-dark-mode-selector">
    <template #button-content>
      <div v-if="!isDarkMode" class="sun-fill">
        <b-icon-sun-fill />
      </div>
      <div v-else class="moon-stars-fill">
        <b-icon-moon-stars-fill />
      </div>
    </template>
    <b-dropdown-item
      class="theme-selector-item d-flex align-items-center gap-3"
      :active="userTheme === 'light'"
      @click="() => handleClickSelector('light')"
    >
      <div class="theme-selector-item--icon">
        <b-icon-sun-fill />
      </div>
      <div class="theme-selector-item--text">
        Light
      </div>
    </b-dropdown-item>
    <b-dropdown-item
      class="theme-selector-item d-flex align-items-center gap-3"
      :active="userTheme === 'dark'"
      @click="() => handleClickSelector('dark')"
    >
      <div class="theme-selector-item--icon">
        <b-icon-moon-stars-fill />
      </div>
      <div class="theme-selector-item--text">
        Dark
      </div>
    </b-dropdown-item>
    <b-dropdown-item
      class="theme-selector-item d-flex align-items-center gap-3"
      :active="userTheme === 'system'"
      @click="() => handleClickSelector('system')"
    >
      <div class="theme-selector-item--icon">
        <b-icon-display />
      </div>
      <div class="theme-selector-item--text">
        System
      </div>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";

export default {
  name: "LightDarkModeSelector",
  props: {
    showLabel: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    ...mapGetters("user", ["isDarkMode", "userTheme"])
  },
  methods: {
    handleClickSelector(theme) {
      if (theme === "dark") {
        document.body.setAttribute('data-theme', 'dark');
        this.$store.commit("user/setIsDarkMode", true);
      } else if (theme === "light") {
        document.body.removeAttribute('data-theme');
        this.$store.commit("user/setIsDarkMode", false);
      } else if (theme === "system") {
        if (window.matchMedia) {
          const darkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
          this.$store.commit("user/setIsDarkMode", darkMode);
          if (darkMode) {
            document.body.setAttribute('data-theme', 'dark');
          } else {
            document.body.removeAttribute('data-theme');
          }
        }
      }
      this.$store.commit("user/setUserTheme", theme);
    },
  },
};
</script>

<style lang="scss">
$theme-selector-dark: #455a64;
$theme-selector-light: #a5abba;
$theme-selector-warm: #fffe7a;
.light-dark-mode-selector {
  >button {
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent !important;
    border: none;
    border-radius: 4px !important;
    padding: 0;

    >div.sun-fill {
      color: $theme-selector-warm;
      background-color: $theme-selector-light;
      padding: 4px;
      border-radius: 4px;
    }

    >div.moon-stars-fill {
      color: $theme-selector-light;
      background-color: $theme-selector-dark;
      padding: 4px;
      border-radius: 4px;
    }

    &::after {
      display: none;
    }
  }

  .theme-selector-item {
    .dropdown-item {
      display: flex;
      align-items: center;
      gap: 1rem;
    }
  }
}
</style>
